import React from 'react';
import starIconOrange from '../../assets/images/starIcon_orange.png';

const ExploreArtistAudio = ({ id }) => {
  const handleAudioClick = () => {
    window.location.href = '/audio-video-production'
  };
  return (
    <div id={id} className="bg-black text-white md:min-h-screen flex items-center justify-center p-4 md:p-8">
      <div className="max-w-6xl w-full grid grid-cols-1 lg:grid-cols-[54%_46%] items-center">
        {/* Left Side - Artistic Text and Graphics */}
        <div className="relative flex flex-col">
          <img className="w-full h-full object-cover" src='http://rummy-assets.jungleerummy.com/Content/versioned/2.0.0.1/images/version4/promotion_june_25/zenrik_images/Pictureasset-management-17512222027601.webp?v=1751222204' />

        </div>

        {/* Right Side - Content */}
        <div className="md:hidden">
          {/* Mobile: Image at top */}
          {/* Mobile: Content box */}
          <div className="md:bg-[#191919e6] rounded-2xl md:p-6 mb-8">
            <h2 className="text-2xl font-normal mb-6 tracking-wide">
              AUDIO<br />
              PRODUCTION
            </h2>

            <div className="space-y-4 text-white-300 text-[18px] md:text-[20px] ">
              <p className='!mt-[22px] flex gap-3 '><img src={starIconOrange}  className="w-6 h-6 inline-block mr-[5px]"/> Pro Production & Mixing</p>
              <p className='!mt-[22px] flex gap-3 '><img src={starIconOrange}  className="w-6 h-6 inline-block mr-[5px]"/> 100+ Projects delivered</p>
              <p className='!mt-[22px] flex gap-3 '><img src={starIconOrange}  className="w-6 h-6 inline-block mr-[5px]"/> ⁠Guided Sessions Support</p>
              <p className='!mt-[22px] flex gap-3 '><img src={starIconOrange}  className="w-6 h-6 inline-block mr-[5px]"/> ⁠Affordable Commercial Sound</p>
            </div>
          </div>

          {/* Mobile: Button */}
          <div className="text-left">
            <button onClick={handleAudioClick} className="bg-[#FF8000] text-white py-[16px] px-[28px] rounded-xl transition-all duration-300 transform hover:scale-105 shadow-xl text-[14px] md:text-[16px] font-normal ">
              Explore Audio Services
            </button>
          </div>
        </div>
        <div className="hidden md:block">
          <div className="space-y-8">
            <div>
              <h2 className="text-[24px] md:text-[40px] font-normal mb-8 leading-tight">
                AUDIO<br />
                PRODUCTION
              </h2>

              <div className="space-y-1 text-white-300 text-[17px] md:text-[20px]">
                <p className='!mt-[20px] flex gap-2 '>
                  <img src={starIconOrange}  className="w-6 h-6 inline-block mr-[5px]"/> Industry standard music production & mixing.
                </p>
                <p className='!mt-[20px] flex gap-2 '>
                  <img src={starIconOrange}  className="w-6 h-6 inline-block mr-[5px]"/> Delivered 100+ songs, ads, and commercial projects.
                </p>
                <p className='!mt-[20px] flex gap-2 '>
                 <img src={starIconOrange}  className="w-6 h-6 inline-block mr-[5px]"/> Supervised sessions with full support.
                </p>
                <p className='!mt-[20px] flex gap-2 '>
                 <img src={starIconOrange}  className="w-6 h-6 inline-block mr-[5px]"/> Commercial quality sound at affordable rates.
                </p>
              </div>
            </div>

            <div >
              <button onClick={handleAudioClick} className="bg-[#FF8000] text-white py-[16px] px-[28px] rounded-xl transition-all duration-300 transform hover:scale-105 shadow-xl text-[14px] md:text-[16px]  font-normal mt-[16px]">
                Explore Audio Services
              </button>
            </div>
          </div></div>
      </div>
    </div>
  );
};

export default ExploreArtistAudio;